import { Footer } from '@common/components/Footer';
import { Box } from '@mui/material';

const PCC_FOOTER_LINK_CONTACT_US_URL = `${import.meta.env.PCC_FOOTER_LINK_CONTACT_US_URL}`;
const PCC_FOOTER_LINK_TERMS_OF_USE_URL = `${import.meta.env.PCC_FOOTER_LINK_TERMS_OF_USE_URL}`;
const PCC_FOOTER_LINK_PRIVACY_POLICY_URL = `${import.meta.env.PCC_FOOTER_LINK_PRIVACY_POLICY_URL}`;
const PCC_FOOTER_LINK_MEIJI_ID_URL = `${import.meta.env.PCC_FOOTER_LINK_MEIJI_ID_URL}`;
const PCC_APP_VERSION = `${import.meta.env.PCC_APP_VERSION}`;
const PCC_APP_ENVIRONMENT = `${import.meta.env.PCC_APP_ENVIRONMENT}`;

/**
 * Campaign site footer.
 * @returns The rendered campaign footer.
 */
export function CampaignFooter() {
  const links = [
    { text: 'お問い合わせ', url: PCC_FOOTER_LINK_CONTACT_US_URL },
    { text: 'ご利用規約', url: PCC_FOOTER_LINK_TERMS_OF_USE_URL },
    { text: '個人情報保護について', url: PCC_FOOTER_LINK_PRIVACY_POLICY_URL },
    { text: '明治会員IDサービスとは', url: PCC_FOOTER_LINK_MEIJI_ID_URL },
  ];

  return (
    <Box sx={{ backgroundColor: '#F9F8F6' }}>
      <Footer
        links={links}
        version={PCC_APP_VERSION}
        environment={PCC_APP_ENVIRONMENT}
      />
    </Box>
  );
}
